export default __webpack_public_path__ + "img/seoul_mucon-0ab65e395d7138bd8d832fa31b232914.png";